<template>
  <div>
    <draggable 
        :list="answers"
                    
                    @start="onDragStart"
                    @end="onDragEnd"
                    :move="onDragMove"
                    align-top
                    handle=".handle"
                   :group="{ name: 'answers', pull: 'clone', put: true }"
                  >
    <template v-for="(answer, jj) in distinctAnswers">
      <v-hover v-slot:default="{ hover }" v-bind:key="jj" v-show="answer.owner.name == maincontact.name || Role('supplier,lead')">
        <q-question :id="'questionCard' + jj" :question="getQuestion(answer)" :hover="hover" :main_answer="answer" :answers="getAnswers(answer)" :impersonate="impersonate"  :show_info="show_info" @answer="answerThis" @cancel="cancel" @update="update" @save="save" @deleteAnswer="removeAnswer"></q-question>
      </v-hover>
      </template>
    </draggable>
    <draggable 
        :list="answers"
                    
                    @start="onDragStart"
                    @end="onDragEnd"
                    :move="onDragMove"
                    align-top
                    handle=".handle"
                   :group="{ name: 'answers', pull: 'clone', put: true }"
                  >
    <h2 class="blue--text text--darken-1 subtitle-1 mb-5 mt-3" v-if="distinctAnswers2.length > 0">Knelpunten</h2>
    <template v-for="(answer, jj) in distinctAnswers2">
      <v-hover v-slot:default="{ hover }" v-bind:key="jj" v-show="answer.owner.name == maincontact.name || Role('supplier,lead')">
        <q-question :id="'questionCard' + jj" :question="getQuestion(answer)" :hover="hover" :main_answer="answer" :answers="getAnswers(answer)" :impersonate="impersonate"  :show_info="show_info" @answer="answerThis" @cancel="cancel" @update="update" @save="save" @deleteAnswer="removeAnswer"></q-question>
      </v-hover>
      </template>
    </draggable>
  </div>
</template>
<script>
import {
  mapState,
  mapMutations,
  mapActions,
  mapGetters
} from 'vuex'
import draggable from "vuedraggable";
export default {
  components: {
        draggable
    },
  props: ['isMain','app','chatMessage',"show_info",'index','impersonate'],
  data: () => ({
      chatMessages: '',
      description: "",
      dragOptions() {
          return {
            animation: 100,
            disabled: false,
            //ghostClass: "ghost",
            pull: 'clone', put: true
          };
        }
  }),
  computed: {
    ...mapState('auth', ["settings","role"]),
    ...mapState('app', ["menu","mini","chat","edit","template"]),
     ...mapState('match', ['selected']),
     ...mapGetters('match', ['question']),
     
       answerProto (){
            return { 
                    owner: {email: this.maincontact.email, name: this.maincontact.name, avatar: this.maincontact.avatar, organisation: this.relation.name, role: this.role}, 
                    date: new Date()
                }
        },
        questions() {
          return this.selected.questions
        },
       messages () {
        if (!this.selected.answers) return []
        if (this.question && this.question.title) return this.selected.answers.filter(a => a.question == this.question.title)
        return this.selected.answers.filter(a => a.question == null || !a.options || a.options.length == 0 || !a.options[0])
      },
      distinctAnswers() {
          console.log(this.answers)
       return removeDuplicates(this.answers.filter(q=>q.answer!=q.question &&(q.owner.name == this.selected.name || 'admin,reseller,lead'.indexOf(q.owner.role)>-1)),'question')
      },
      distinctAnswers2() {
       return removeDuplicates(this.answers.filter(q=>q.answer==q.question && q.type=='text' && (q.owner.name == this.selected.name || 'admin,reseller,lead'.indexOf(q.owner.role)>-1)),'question')
      },
      answers () {
          return this.selected.answers
      },
    myAnswers () {
      var self = this
      return this.selected.answers.filter(a => a.owner.name == self.maincontact.name)
    },
     showChat: {
      get() {
        return this.chat
      },
      set(value) {
        this.setChat(value)
      }
    },
    placeholder () {
        if (this.question && this.question.title) return "Opmerking bij '" + this.question.title + "'"
        return 'Opmerking...'
    },
    currentQuestion: {
            get() {
                 return this.question
            },
            set(value) {
                this.setQuestion(value)
            }
      },
  },
  mounted(){
      var self = this
      this.$nextTick(() => self.$emit('scroll'))
  },
  methods: {
    ...mapMutations('app', ["setChat"]),
     ...mapActions('match', ["addAnswer"]),
     ...mapMutations('match', ["deleteAnswer","addDescription","updateAnswer","setQuestion"]),
     ...mapGetters('auth', ["Role","maincontact","relation"]),
     onDragMove(e) {
            },
            onDragStart(evt) {
               //this.currentQuestion = this.questions[evt.oldIndex]
                //this.currentQuestion.drag=true
                this.dragIndex = evt.oldIndex
                this.drag = true
            },
            onDragEnd(evt) {
             // this.questions[evt.newIndex].drag=false
              this.dragIndex = -1
              this.drag = false  
              this.modified=true
              this.save()
            
      
       },
      addChat(){
        var self = this
        if (!this.chatMessage || this.chatMessage.length == 0) return false
        var a = { 
            _id: this.selected._id,
            owner: {email: this.maincontact.email, name: this.maincontact.name, avatar: this.maincontact.avatar, organisation: this.relation.name, role: this.role}, 
            date: new Date(),
            text: self.chatMessage
        }
        if (this.question && this.question.title) a.question = this.question.title
        this.addAnswer(a)
        this.$nextTick(() => self.$emit('scroll'))
      },
       save() {
         this.$emit('save')
       },
      removeAnswer(answer) {
            this.deleteAnswer(answer)
            this.save()
        },
      answerThis(question) {
        this.$emit('answer', question)
      },
      addToAnswer(question) {
        var answer = this.getMyAnswer(question)
        answer.text = question.text
        this.updateAnswer(answer)
        question.text = ''
        this.save()
      },
      update(text,answer) {
          answer.text = text
          this.updateAnswer(answer)
          this.save()
          //this.cancel()  
          //this.updateAnswer(answer)
      },
      cancel () {
        this.setQuestion({title:''} )
      },
      timeStamp (date){
        if (!date) return
        var m = this.$moment(date, this.$moment.ISO_8601)
        if (!m.isValid()) return this.$moment().format("dddd D MMMM [om] HH:mm")
        return   m.format("dddd D MMMM [om] HH:mm");
      },
      close () {
          this.setChat(false)
      },
       questionMark(question) {
              if (question.title && question.title.indexOf('?') == -1) return '?'
          },
        getMyAnswer(question) {
          var self = this
          var arr = this.answers.filter(a => a.question == question.title && a.owner && a.owner.name == self.maincontact.name)
          if (!arr || arr.length==0) return {}
          return arr[0]
        },
         getQuestion(answer) {
          var self = this
          var arr = this.questions.filter(question => answer.question == question.title)
          if (!arr || arr.length==0) return {}
          return arr[0]
        },
        getAnswers(answer) {
          var self = this
          var arr = this.answers.filter(a => a.question == answer.question)
          if (!arr || arr.length==0) return []
          return arr
        },
        hasAnswered(question) {
           var self = this
            if (!this.answers || this.answers.length == 0) return false
            return this.answers.filter(a => a.question == question.title && (question.type=='text' || (a.options && a.options.length>0 && a.options[0])) && a.owner && a.owner.name == self.maincontact.name).length > 0
        },
       avatar (url) {
          return this.$config.getIMageLink('logo',url,true)
        }
  }
};

function removeDuplicates(myArr, prop) {
    return myArr.filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
    });
}

</script>
<style>
.remove-button {
  float: right;
  
    margin-top: 2px;
    position: absolute;
    margin-left: 20px;
}
</style>